import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IEnvironment } from 'src/environments/environment.model';

import { Grant, GrantSummary, Visit } from 'src/app/modules/core/models/realtor.model';
import { SettingsService } from 'src/app/modules/core/services/settings.service';

import { withSpinner } from 'src/app/modules/shared/extensions/withSpinner.extension';
import { UnsubscribeOnDestroy } from 'src/app/modules/shared/utilities/unsubscribe-on-destroy';

@Injectable({
	providedIn: 'root'
})
export class RealtorService extends UnsubscribeOnDestroy {	
	private settings!: IEnvironment;

	constructor(private _http: HttpClient,
		settingsService: SettingsService) {
		super();

		settingsService.getSettings().pipe(
			this.takeUntilDestroyed()
		).subscribe(settings => {
			this.settings = settings;
		});
	}

	getGrants(realtorEmail?: string, salesAgreementId?: number): Observable<GrantSummary[]> {
		const url = `${this.settings?.apiUrl}realtor/grants`;
		const params: { realtorEmail?: string; salesAgreementId?: number } = {};

		if (realtorEmail) params['realtorEmail'] = realtorEmail;
		if (salesAgreementId) params['salesAgreementId'] = salesAgreementId;

		return this._http.get<GrantSummary[]>(url, { params });
	}

	acknowledgeAccess(grantId: string): Observable<Grant> {
		const url = `${this.settings?.apiUrl}realtor/grants/${grantId}/acknowledge`;
		return withSpinner(this._http).put<Grant>(url, { grantId });
	}

	removeAccess(grantId: string): Observable<Grant> {
		const url = `${this.settings?.apiUrl}realtor/grants/${grantId}/revoke`;
		return withSpinner(this._http).put<Grant>(url, { grantId });
	}

	reactivateAccess(grantId: string): Observable<Grant> {
		const url = `${this.settings?.apiUrl}realtor/grants/${grantId}/reactivate`;
		return withSpinner(this._http).put<Grant>(url, { grantId });
	}

	createGrant(marketId: number, salesAgreementId: number, realtorEmail: string): Observable<Grant> {
		const url = `${this.settings?.apiUrl}realtor/grants`;
		return withSpinner(this._http).post<Grant>(url, { marketId, salesAgreementId, realtorEmail });
	}

	upsertVisit(marketId: number, salesAgreementId: number): Observable<Visit> {
		const url = `${this.settings?.apiUrl}realtor/visits`;
		const params = { marketId: marketId, salesAgreementId: salesAgreementId };
		return withSpinner(this._http).put<Visit>(url, null, { params });
	}
}